export function getCorrectOption(correctAnswers, options) {
  const answers = {};
  if (!correctAnswers) return {};
  options.forEach((option) => {
    answers[option.optionId] = correctAnswers.includes(option.optionId);
  });
  return answers;
}
